import React, { FC } from 'react';
import { Start, Stop, Svg } from './styles';

const Menu: FC<SVGIconProps> = ({ linearGradient }) => (
  <Svg width="64" height="64" viewBox="0 0 64 64" fill="none">
    <path
      d="M8 16H56V21.3333H8V16ZM8 29.3333H56V34.6667H8V29.3333ZM8 42.6667H56V48H8V42.6667Z"
      fill="url(#paint0_linear_233_109)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_233_109"
        x1="32.0001"
        y1="0.0909161"
        x2="37.1552"
        y2="51.1811"
        gradientUnits="userSpaceOnUse"
      >
        <Start startColor={linearGradient?.startColor} />
        <Stop stopColor={linearGradient?.stopColor} offset="1" />
      </linearGradient>
    </defs>
  </Svg>
);

export default Menu;
